import React from "react";
import PropTypes from "prop-types";
import { Spin } from "antd";

export const GlobalRouteLoader = ({ label = "Loading page..." }) => (
    <div className="hms-route-loader" role="status" aria-live="polite">
        <Spin />
        <span>{label}</span>
    </div>
);

GlobalRouteLoader.propTypes = {
    label: PropTypes.string,
};
